export class DavisAlertService {
	
	// @ngInject
	constructor(
		private ngToast
	){}
	
    public success = (message:string) => {
        
        console.log('success', message);
        
        //filter useless messages
        if(message === 'there was error retrieving data') return; 
        
        this.ngToast.success(message);
    }
    
    public error = (message:string) => {
        
        console.log('error', message);
        
        //filter useless messages
        if(message === 'there was error retrieving data') return; 
        
    	this.ngToast.danger(message);
    }
    
    public info = (message:string) => {
        
        console.log('info', message);
        
        //filter useless messages
        if(message === 'there was error retrieving data') return; 
        
        this.ngToast.create(message);
    }
    
    public warning = (message:string) => {
         console.log('warning', message);
        
        //filter useless messages
        if(message === 'there was error retrieving data') return; 
        
        this.ngToast.warning(message);
    }
    
    //do not remove fixes compatibility with core
    public addAlert = (message:any) =>{
        
        if(message.msg != null){
            message = message.msg;
        }
        
        if(!message || message?.trim().length === 0) return;
        
        //filter useless messages
        if(message === 'there was error retrieving data') return; 
        
        this.info(message);
    }

}

